import React from 'react';
import './keepmeinformed.css';
import LogoVwmHeader from './recursos/web/logo_vwm_header.png';
import CelMultimarca from './recursos/web/header/img_multibrand_web.png';
import CelMultimarcaMobile from './recursos/mobile/header/img_multibrand_movil.png';
import HeaderAudi from './recursos/web/header/header_audi.png';
import HeaderAudiMobile from './recursos/mobile/header/header_audi.png';
import HeaderSeat from './recursos/web/header/header_seat.png';
import HeaderSeatMobile from './recursos/mobile/header/header_seat.png';
import HeaderVw from './recursos/web/header/header_vw.png';
import HeaderVwMobile from './recursos/mobile/header/header_vw.png';
import HeaderVwvc from './recursos/web/header/header_vwvc.png';
import HeaderVwvcMobile from './recursos/mobile/header/header_vwvc.png';
import CheckMenu from './recursos/web/menu/ico_proceso.svg';
import MailMenu from './recursos/web/menu/ico_contacta.svg';
import ImgPoster from './recursos/web/body/conoce.png';
import BodyCompra from './recursos/web/body/proceso.png';
import BodyContacta from './recursos/web/body/contacta.png';
import BodyRuta from './recursos/web/body/ruta.png';
import BodyInstalaAudi from './recursos/web/body/ico_audi.svg';
import BodyInstalaSeat from './recursos/web/body/ico_instala_seat.png';
import BodyInstalaVw from './recursos/web/body/ico_instala_vw.png';
import BodyInstalaVwvc from './recursos/web/body/ico_VWcomerciales.svg';
import BodyIcoRuta from './recursos/web/body/ico_ruta.svg';
import FooterDto from './recursos/web/footer/dto.png';
import FooterMultimarca from './recursos/web/footer/multimarca.png';

class KeepMeInformed extends React.Component {
    render() {
        return(
            <React.Fragment>
                <div className="header_kmi_vwm__container">
                    <img src={LogoVwmHeader} alt="Logo vwm header" />
                </div>
                <div className="main__container">
                    <div className="container">
                        <div className="row mt-3 ml-0 mr-0 mb-lg-5 mb-xl-5 justify-content-md-center">
                            <div className="col-lg-5 text-lg-left text-xl-left text-md-center text-ms-center">
                                <div className="row">
                                    <div className="col-lg-9 col-lg-offset-2">
                                        <h1 className="text-lg-left text-xl-left text-md-center text-ms-center text-center">
                                            <span className="font-weight-light titulo-principal">Sigue tu</span>
                                            <br />
                                            <strong className="text-marcas mb-lg-3">Volkswagen, Audi y SEAT.</strong>
                                        </h1>
                                        <p className="text-lg-left text-center">
                                            <span className="font-weight-light">La </span>
                                            <span className="font-weight-bold">Funcionalidad WEB </span> 
                                            <span className="font-weight-light">multimarca de </span> 
                                            <span className="font-weight-bold">Volkswagen de México</span> 
                                            <span className="font-weight-light">, que te </span> 
                                            <span className="font-weight-light"></span> 
                                            <span className="font-weight-bold">mantiene informado </span> 
                                            <span className="font-weight-light">en todo </span> 
                                            <span className="font-weight-bold">tu proceso de compra.</span>
                                        </p>
                                        <p className="text-lg-left text-center font-weight-bold">Para Seguir tu Volkswagen, Audi y SEAT selecciona tu marca:</p>
                                        <div className="row mb-4">
                                            <div className="col-lg-3 col-xl-3 col-3">
                                                <a className="d-none d-lg-block d-xl-block header_icon_web" href={process.env.REACT_APP_URL_VW}><img src={HeaderVw} className="img-fluid" alt="Logo vw" /></a>
                                                <a className="d-block d-lg-none d-xl-none" href={process.env.REACT_APP_URL_VW}><img src={HeaderVwMobile} alt="Logo vw mobile" /></a>
                                            </div>
                                            <div className="col-lg-3 col-xl-3 col-3">
                                                <a className="d-none d-lg-block d-xl-block header_icon_web"  href={process.env.REACT_APP_URL_AUDI}><img src={HeaderAudi} alt="Logo audi" /></a>
                                                <a className="d-block d-lg-none d-xl-none"  href={process.env.REACT_APP_URL_AUDI}><img src={HeaderAudiMobile} alt="Logo audi mobile" /></a>
                                            </div>
                                            <div className="col-lg-3 col-xl-3 col-3">
                                                <a className="d-none d-lg-block d-xl-block header_icon_web"  href={process.env.REACT_APP_URL_SEAT}><img src={HeaderSeat} alt="Logo seat" /></a>
                                                <a className="d-block d-lg-none d-xl-none"  href={process.env.REACT_APP_URL_SEAT}><img src={HeaderSeatMobile} alt="Logo seat mobile" /></a>
                                            </div>
                                            <div className="col-lg-3 col-xl-3 col-3">
                                                <a className="d-none d-lg-block d-xl-block header_icon_web"  href={process.env.REACT_APP_URL_VW}><img src={HeaderVwvc} alt="Logo vwvc" /></a>
                                                <a className="d-block d-lg-none d-xl-none"  href={process.env.REACT_APP_URL_VW}><img src={HeaderVwvcMobile} alt="Logo vwvc mobile" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-6 col-sm-12 col-12 space-no-padding">
                                <img className="d-none d-lg-block d-xl-block img-fluid" src={CelMultimarca} alt="Cel multimarca" />
                                <img className="d-block d-lg-none d-xl-none img-fluid" src={CelMultimarcaMobile} alt="Cel multimarca" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-6 menu">
                            <div className="ico">
                                <a href="#Compra"><img src={CheckMenu} alt="check" /></a>
                            </div>
                            <span className="font-weight-bold text-secondary">Proceso de<br /> compra</span>
                        </div>
                        <div className="col-lg-4 col-6 menu">
                            <div className="ico">
                                <a href="#Contacta"><img src={MailMenu} alt="correo" /></a>
                            </div>
                            <span className="font-weight-bold text-secondary">Contacta al<br />concesionario</span>
                        </div>
                        
                        <div className="col-lg-4 col-6 menu">
                            <div className="ico">
                                <a href="#Ruta"><img src={BodyIcoRuta} alt="historial" /></a>
                            </div>
                            <span className="font-weight-bold text-secondary">La mejor ruta a<br />tu concesionario</span>
                        </div>
                    </div>
                </div>

                <div id="CompraConoce" className="tarjeta odd">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 mt-5 orden">
                                
                                    <h4 className="font-weight-light">
                                        <strong>Conoce las funciones de</strong>
                                    </h4>
                                    <h4 className="font-weight-light">
                                        <strong>Sigue tu Volkswagen, Audi y SEAT.</strong>
                                    </h4>
                                
                                <div className="mt-4">
                                    <ul className="list-unstyled">
                                        <li className="font-weight-light">Te presentamos Sigue tu Volkswagen, Audi y SEAT, en este video conocerás las principales características de esta Progressive WEB App.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-5 mt-5 text-lg-left text-xl-left text-center">
                                <video style={{width: "100%"}} poster={ImgPoster} controls>
                                    <source src={process.env.REACT_APP_URL_VIDEO} type="video/mp4" />
                                </video> 
                            </div>
                        </div>
                    </div>
                </div>

                <div id="Compra" className="tarjeta">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 text-lg-left text-xl-left text-center">
                                <img src={BodyCompra} alt="compra" />
                            </div>
                            <div className="col-lg-7 mt-5">
                                <div>
                                    <h4 className="font-weight-light">
                                        <strong>Proceso de compra</strong>
                                    </h4>
                                </div>
                                <div className="mt-4">
                                    <ul className="list">
                                        <li className="font-weight-light">¿Dónde se encuentra tu vehículo?</li>
                                        <li className="font-weight-light">Fecha compromiso de entrega en la concesionaria</li>
                                        <li className="font-weight-light">Consulta el estado de tu compra</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="Contacta" className="tarjeta odd">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 texto orden">
                                <div className="mt-5">
                                    <h4 className="font-weight-light">
                                        <strong>Contacta al concesionario</strong>
                                    </h4>
                                </div>
                                <div className="mt-4">
                                    <ul className="list-unstyled">
                                        <li className="font-weight-light">Te facilitamos los canales de comunicación con tu concesionario para que puedas resolver cualquier duda que tengas de tu proceso de compra.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-5 text-lg-right text-xl-right text-center">
                                <img src={BodyContacta} alt="historial" />
                            </div>
                        </div>
                    </div>
                </div>
                {/**
                <div id="Sociales" className="tarjeta">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 text-lg-left text-xl-left text-center">
                                <img src={BodyTwitter} alt="comparte" />
                            </div>
                            <div className="col-lg-7 mt-5">
                                <div>
                                    <h4 className="font-weight-light">Comparte en redes sociales</h4>
                                </div>
                                <div className="mt-4">
                                    <ul className="list-unstyled">
                                        <li className="font-weight-light">Comparte en tu página de facebook</li>
                                        <li className="font-weight-light">Comparte en twitter</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 */}
                <div id="Ruta" className="tarjeta">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-5 text-lg-left text-xl-left text-center">
                                <img src={BodyRuta} alt="historial" />
                            </div>
                            <div className="col-lg-7 texto orden">
                                <div className="mt-5">
                                    <h4 className="font-weight-light">
                                        <strong>La mejor ruta a tu concesionario</strong>
                                    </h4>
                                </div>
                                <div className="mt-4">
                                    <ul className="list-unstyled">
                                        <li className="font-weight-light">Cuando te confirmemos que tu auto nuevo está listo para su entrega te ayudamos a encontrar la mejor ruta al concesionario o a solicitar un taxi con tu aplicación de transporte preferida.</li>
                                    </ul>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div className="instala apps odd">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-xl-12 mt-3 mb-4">
                                <div className="row mt-3">
                                    <div className="col">
                                        <h1 className="text-md-center text-lg-center text-xl-center text-install-app">
                                            <span className="font-weight-light">Sigue tu Volkswagen, Audi y SEAT </span>
                                            <small>(selecciona tu marca)</small>
                                        </h1>
                                    </div>
                                </div>
                                <div className="row mt-3 mb-3">
                                    <div className="col-sm-2 col-12 mb-3 mt-3">
                                    </div>
                                    <div className="col-sm-2 col-6 mb-3 mt-3">
                                        <a href={process.env.REACT_APP_URL_VW}><img className="d-block mx-auto" src={BodyInstalaVw} alt="ico vw"/></a>
                                    </div>
                                    <div className="col-sm-2 col-6 mb-3 mt-3">
                                        <a href={process.env.REACT_APP_URL_AUDI}><img className="d-block mx-auto" src={BodyInstalaAudi} alt="ico audi"/></a>
                                    </div>
                                    <div className="col-sm-2 col-6 mb-3 mt-3">
                                        <a href={process.env.REACT_APP_URL_SEAT}><img className="d-block mx-auto" src={BodyInstalaSeat} alt="ico seat"/></a>
                                    </div>
                                    <div className="col-sm-2 col-6 mt-3">
                                        <a href={process.env.REACT_APP_URL_VW_COMERCIALES}><img className="d-block mx-auto" src={BodyInstalaVwvc} alt="ico vwvc"/></a>
                                    </div>
                                </div>
                            </div>
                        </div>                 
                    </div>
                </div>

                <div className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 col-lg-2 col-7 offset-0 offset-md-0 offset-lg-0">
                                <div className="cnt-cp">
                                    <span className="cp-vw">&copy; Volkswagen de México 2021</span>
                                </div>
                            </div>
                            <div className="col-md-2 col-lg-1 col-4 offset-1 offset-md-0 offset-lg-0 text-md-center text-right">
                                <img src={FooterDto} alt="dto" />
                            </div>
                            <div className="col-md-6 col-lg-2 col-12 offset-0 offset-md-1 offset-lg-5 text-lg-right text-md-right text-center">
                                <img src={FooterMultimarca} alt="multimarca" />
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default KeepMeInformed;